var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItPasswordInvisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,12c0-0.7-0.3-1.4-0.7-1.9L14.7,9c0.8,0.8,1.3,1.9,1.3,3c0,2.2-1.7,3.9-3.9,4l0.4-1.1C13.9,14.7,15,13.5,15,12z M3.1,12 C4.8,8.6,8.2,6.5,12,6.5h0.4l0.4-0.9H12c-4.1,0-7.9,2.3-9.8,6L2,12l0.2,0.5c1.3,2.5,3.5,4.4,6.1,5.3l0.3-0.9 C6.2,16,4.2,14.3,3.1,12z M21.8,11.5c-1.3-2.5-3.5-4.4-6.1-5.3l-0.3,0.9c2.4,0.9,4.4,2.6,5.5,4.9c-1.7,3.4-5.1,5.5-8.9,5.5h-0.4 l-0.4,0.9H12c4.1,0,7.9-2.3,9.8-6L22,12L21.8,11.5z M11.5,9.1L11.9,8C9.7,8.1,8,9.8,8,12c0,1.1,0.5,2.2,1.3,3l0.4-1.1 C9.3,13.4,9,12.7,9,12C9,10.5,10.1,9.3,11.5,9.1z M14.6,3.4L8.5,20.3l0.9,0.3l6.1-16.9L14.6,3.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItPasswordInvisible);
export default __webpack_public_path__ + "static/media/it-password-invisible.bf00ceaa.svg";
export { ForwardRef as ReactComponent };